import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import utils from '@/utils';

Vue.use(Vuex);

// 导入当前文件夹下面所有文件
const moduleFiles = require.context('./modules', true, /\.js$/);

// 解析导入的文件
const modules = utils.resolveRequire(moduleFiles);

// 创建VuexPersistence实例,用于持久化vuex状态
const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    modules: ['user', 'cache', 'sidebar']
});

// 创建store实例
const store = new Vuex.Store({
    modules,
    plugins: [vuexLocal.plugin]
});

export default store;
